


















import Vue from 'vue'

export default Vue.extend({
  computed: {
    availableSlots() {
      return ['first', 'second'].filter(s => this.$slots[s])
    },
  },
})
